import React from "react";
import HeroSection from "../containers/AndroidServices/HeroSection";
import Section_one from "../containers/AndroidServices/Section_one";
import Expert from "../containers/AndroidServices/ExpertAndroid";
import OurApps from "../containers/AndroidServices/ourWork"
const AndroidDevelopment = () => {
  return (
    <>
      <HeroSection />
      <Section_one />
      <OurApps />
      <Expert />
    </>
  );
};

export default AndroidDevelopment;
